module.exports = __webpack_public_path__ + "h5/img/noCoupon.cca04173.png";